import { RelayEnvironmentProvider } from 'react-relay';

import { Environment } from '@feedback/main/src/relay';

import Root from './Root';

const OmbudsmanExtRoot = () => {
  return (
    <RelayEnvironmentProvider environment={Environment}>
      <Root />
    </RelayEnvironmentProvider>
  );
};

export default OmbudsmanExtRoot;
